import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ onNavigate }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => {
          if (onNavigate) {
            onNavigate('home');
          } else {
            scrollToSection('hero');
          }
        }}>
          <span className="logo-text">Bulut Ambalaj</span>
        </div>
        
        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <a href="#hero" onClick={(e) => { 
            e.preventDefault(); 
            if (onNavigate) {
              onNavigate('home');
            } else {
              scrollToSection('hero');
            }
          }}>Ana Sayfa</a>
          <a href="#about" onClick={(e) => { 
            e.preventDefault(); 
            if (onNavigate) {
              onNavigate('about');
            } else {
              scrollToSection('about');
            }
          }}>Hakkımızda</a>
          <a href="#products" onClick={(e) => { 
            e.preventDefault(); 
            if (onNavigate) {
              onNavigate('products');
            } else {
              scrollToSection('products');
            }
          }}>Ürünlerimiz</a>
          <a href="#contact" onClick={(e) => { 
            e.preventDefault(); 
            if (onNavigate) {
              onNavigate('contact');
            } else {
              scrollToSection('contact');
            }
          }}>İletişim</a>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
